import { useMemo } from 'react';
import { IntransitBasePage } from './IntransitBasePage';
import { formatCurrency, formatDate, currencySortingFn } from '../utils/formatters';

export function IntransitQuotationsPage() { 

  const columns = useMemo(
    () => [
      {
        accessorKey: 'partner_id',
        header: 'Company',
      },
      {
        accessorKey: 'date_order',
        header: 'Quotation date',
        cell: (info) => info.getValue() ? formatDate(new Date(info.getValue()), 'P') : '-',
      },
      {
        accessorKey: 'name',
        header: 'SO',
        cell: (info) => (
          <a href={info.row.original.url} target="_blank" rel="noopener noreferrer">
            {info.getValue()}
          </a>
        ),
      },
      {
        id: 'contents',
        header: 'Contents',
        cell: (info) => (
          <div className="d-flex flex-column gap-1">
            {(info.row.original.lines || []).map((line) => (
              <div key={line.id}>
                <b>{line.product_uom_qty}</b> x{' '}
                <a href={line.product?.url} target="_blank" rel="noopener noreferrer">
                  {line.product?.default_code}
                </a>{' '}
                <small className="text-muted">{line.product?.name}</small>
              </div>
            ))}
          </div>
        ),
      },
      {
        accessorKey: 'amount_total',
        header: 'Amount total',
        sortingFn: currencySortingFn,
        cell: (info) => {
          const val = info.getValue();
          if (typeof val === 'object' && val !== null) return formatCurrency(val);
          return formatCurrency({ amount: val ?? 0, currency: info.row.original?.currency_id });
        },
      },
      {
        accessorKey: 'user_id',
        header: 'Seller',
     },
    ],
    []
  );

  const globalFilterFn = (row, columnId, filterValue) => {
    const search = filterValue.toLowerCase();
    const name = (row.original.name || '').toLowerCase();
    const partner = (row.original.partner_id || '').toLowerCase();
    if (name.includes(search) || partner.includes(search)) return true;

    return (row.original.lines || []).some((line) =>
      (line.product?.name || '').toLowerCase().includes(search) ||
      (line.product?.default_code || '').toLowerCase().includes(search)
    );
  };

  return (
    <IntransitBasePage 
      mode="quotations" 
      label="Quotations" 
      columns={columns}
      globalFilterFn={globalFilterFn}
      searchHelp="Search by SO, Company, or Product (Name/SKU)"
    />
  );
}
